var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('Scene',{ref:"scene",attrs:{"id":_vm.scene_id,"title":_vm.scene.title,"media":_vm.scene.media,"trackPostTime":_vm.scene.trackPostTime,"cover":_vm.scene.cover,"nextPath":_vm.next_scene}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }